import { ColumnsType } from "antd/es/table";
import { FileTextOutlined } from "@ant-design/icons";
import { formatPhoneNumber } from "../../../../utils/MascaraDeCampos";
import { useColumnDateTimeSearch } from "../../../../hooks/FilterTable/date";
import { useGetColumnSearchPropsTypeString } from "../../../../hooks/FilterTable/objString";
import { Button, Table, Tag, Tooltip, Typography } from "antd";
import { IContratos, ISolicitacaoDeRecuperacaoReceitas, ISolicitacoesTab } from "../../interfaces";
import { useRef } from "react";

const SolicitacoesTab: React.FC<ISolicitacoesTab> = ({
    data,
    themeState,
    loadingTable,
    showModal,
}) => {
    const { Text } = Typography;

    const ColumnsSolicitacoesTab: ColumnsType<ISolicitacaoDeRecuperacaoReceitas> = [
        {
            title: "Nome",
            dataIndex: "usuario_nome",
            key: "usuario_nome",
            ellipsis: true,
            width: 120,
            ...useGetColumnSearchPropsTypeString('usuario_nome'),
        },
        {
            title: "Contratos",
            dataIndex: "contratos",
            key: "contratos",
            ellipsis: true,
            width: 220,
            ...useGetColumnSearchPropsTypeString("contratos"),
            onFilter: (value, record) => record.contratos.some((contrato) => contrato.nome.toLowerCase().includes(String(value).toLowerCase())),
            render: (contratos: IContratos[]) => (
                <>
                    {contratos.map((contrato) => (
                        <Tag key={contrato._id}>
                            {contrato.nome.toUpperCase()}
                        </Tag>
                    ))}
                </>
            ),
        },
        {
            title: "Município",
            dataIndex: "cidade_nome",
            key: "cidade_nome",
            ellipsis: true,
            width: 150,
            ...useGetColumnSearchPropsTypeString('cidade_nome')
        },
        {
            title: "Telefone",
            dataIndex: "usuario_telefone",
            key: "usuario_telefone",
            width: 120,
            ...useGetColumnSearchPropsTypeString('usuario_telefone'),
            render: (telefone: number) => {
                const tel = telefone?.toString();
                const telFormatted = formatPhoneNumber(tel, false);
                return (
                    <>
                        {telFormatted && (
                            <div>
                                <span>
                                    {telFormatted}
                                </span>
                            </div>
                        )}
                    </>
                );
            },
        },
        {
            title: "Fonte",
            dataIndex: "fonte",
            key: "fonte",
            width: 110,
            ellipsis: true,
            ...useGetColumnSearchPropsTypeString('fonte'),
        },
        {
            title: "Solicitada em",
            dataIndex: "recebida_em",
            key: "recebida_em",
            width: 120,

            ...useColumnDateTimeSearch('recebida_em'),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 110,
            filters: [
                { text: "Solicitado", value: "Solicitado" },
                { text: "Em Análise", value: "Em Análise" },
                { text: "Concluído", value: "Concluído" },
                { text: "Fechado", value: "Fechado" },
            ],
            onFilter: (value, record) => record.status === value,
            render: (status: string) => {
                const color = status ===
                    "Solicitado" ? "blue" :
                    status === "Em Análise" ? "orange" :
                        status === "Concluído" ? 'green' :
                            status === 'Fechado' ? 'red' :
                                "gray";
                return <Tag color={color}>{status.toUpperCase()}</Tag>;
            },
        },
        {
            title: "Ação",
            width: 50,
            render: (record: ISolicitacaoDeRecuperacaoReceitas) => {
                return (
                    <div className="divAcao">
                        <Tooltip
                            title="Atualizar solicitação"
                            color="blue"
                        >
                            <Button
                                type="primary"
                                icon={<FileTextOutlined />}
                                onClick={() => showModal(record)}
                            />
                        </Tooltip>
                    </div>
                );
            },
        }
    ];

    const refTotalFiltrado = useRef<ISolicitacaoDeRecuperacaoReceitas[]>([]);

    return (
        <>
            <Table
                columns={ColumnsSolicitacoesTab}
                dataSource={data}
                rowKey={(record) => record._id}
                loading={loadingTable}
                size="small"
                pagination={{
                    locale: { items_per_page: '' },
                    showSizeChanger: true,
                    defaultPageSize: 10,
                    pageSizeOptions: ['10', '25', '50', '75', '100'],
                }}
                onChange={(_, __, ___, extra) => {
                    refTotalFiltrado.current = extra.currentDataSource;
                }}
                scroll={{ x: 1000 }}
                title={(registros) => {
                    return (
                        <div style={{
                            backgroundColor: themeState === 'light' ? '#FAFAFA' : '#1D1D1D',
                            padding: 10,
                            marginBottom: -8,
                            margin: -8,
                            textAlign: 'end',
                        }}>
                            <Text>
                                {`Mostrando: ${registros.length} de ${refTotalFiltrado.current.length > 0 ? refTotalFiltrado.current.length + ' em' : ''} um total de ${data.length} Receitas`}
                            </Text>
                        </div>
                    )
                }}
                footer={(registros) => {
                    return (
                        <div style={{ textAlign: 'end' }}>
                            <Text>
                                {`Mostrando: ${registros.length} de ${refTotalFiltrado.current.length > 0 ? refTotalFiltrado.current.length + ' em' : ''} um total de ${data.length} Receitas`}
                            </Text>
                        </div>
                    )
                }}
            />
        </>
    )
}
export default SolicitacoesTab;
